import React, { FC } from 'react';
import { Article } from 't2-graphql-types';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';
import { PaginatedArticlesList } from '../PaginatedArticlesList/PaginatedArticlesList';
import { TPostCardProps } from '../PostCard/types';
import { PostCard } from '../PostCard/PostCard';
import { usePromptPageContext } from '../Prompt/context/PromptPageContext';
import { PROMPT_REPLIES_PAGE_SIZE } from '../Prompt/constants';

type TPromptArticlesSectionContainerProps = {
  promptId: Article['id'];
};

const CardWithPreview = ({ ...props }: Omit<TPostCardProps, 'onPreviewClick'>) => {
  const { preview } = usePromptPageContext();

  const handlePreviewClick = () => {
    preview.setState({ articleId: props.article.id });
  };

  return <PostCard onPreviewClick={handlePreviewClick} {...props} />;
};

export const PromptArticlesSectionContainer: FC<TPromptArticlesSectionContainerProps> = ({ promptId }) => {
  const { sendEvent } = useAnalytics();
  const {
    prompt: { data, loading, refetch, error, fetchMore },
  } = usePromptPageContext();
  const count = data?.article.childArticlesCount || 0;

  const onArticleCardClick = (articleId: string) => () => {
    sendEvent('prompt_post_card_click', { prompt_id: promptId, post_id: articleId });
  };

  return (
    <PaginatedArticlesList
      listSection={{
        title: 'Posts',
        className: 'order-4',
        loading,
      }}
      content={{
        items: data?.article?.childArticles || [],
        itemCount: count,
        emptyMessage: 'There are no replies to this prompt yet',
        onItemClick: onArticleCardClick,
        refetch,
        error: !!error,
        loading,
        component: CardWithPreview,
        fetchMore,
      }}
      pageSize={PROMPT_REPLIES_PAGE_SIZE}
    />
  );
};
